// extracted by mini-css-extract-plugin
module.exports = {"seriesListWrapper":"pp","fullWidth":"pq","seriesListTabWrapper":"pr","tab":"ps","active":"pt"};